var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},_vm.$listeners),[_c('path',{attrs:{"d":"M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm16 384c0 8.824-7.178 16-16 16H64c-8.822 0-16-7.176-16-16V160h416v256z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }